import { Box, CircularProgress, Pagination, Stack, Tooltip, Typography } from '@mui/material';
import CustomButton from '@src/components/CustomButton/CustomButton';
import CustomDataGrid2 from '@src/components/CustomDataGrid/CustomDataGrid2';
import LabeledSelectField from '@src/components/CustomSelect/LabeledSelectField';
import LabeledTextField from '@src/components/CustomTextField/LabeledTextField';
import PageHeader from '@src/components/PageHeader/PageHeader';
import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CustomAlert from '@src/components/CustomAlert/CustomAlert';
import CustomDatePicker from '@src/components/CustomDatePicker/CustomDatePicker';
import { InfoOutlined } from '@mui/icons-material';
import moment from 'moment';
import { useAppSelector } from '@src/store/hooks';
import { RESTAURANT } from '@src/Constants';
import { roundToInt } from '@src/helpers/Helpers';
import { IsMobileWidth } from '@src/components/MediaQueryUtils';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	background-color: var(--chat-header-bg);
	transition: width 0.3s ease;

	.addBtn {
		// width: 172px;
		height: 36px;
		border-radius: 4px;
		padding: 7px 12px 7px 12px;
		margin-bottom: 15px;
	}
`;

function TopFIlterMobileView({
	searchByDate,
	filterByType,
	currentSelectedOrg,
	setCurrentSelectedOrg,
	organizations,
	isRestaurant,
	selectedDates,
	setSelectedDates,
	onApply,
	onClear,
}: any) {
	return (
		<Stack direction={'column'} justifyContent="space-between" p={2} gap={2} width={'100%'}>
			<Stack>
				<Typography>Filter By Date Range</Typography>
				<Stack direction={'row'} gap={1}>
					<CustomDatePicker
						label="From"
						styles={{ height: '36px', width: 300 }}
						selectedDate={selectedDates.fromDate}
						onDateChange={(newDate) => setSelectedDates({ ...selectedDates, fromDate: newDate })}
					/>
					<CustomDatePicker
						label="To"
						styles={{ height: '36px', width: 300 }}
						selectedDate={selectedDates.fromDate}
						minDate={selectedDates.fromDate}
						onDateChange={(newDate) => setSelectedDates({ ...selectedDates, toDate: newDate })}
					/>
				</Stack>
				<Stack direction={'row'} gap={1}>
					<CustomButton
						title={'Apply'}
						styles={{ height: '33px', marginBottom: '3px' }}
						handleClick={() => onApply()}
					/>
					<CustomButton
						title={'Clear'}
						styles={{
							height: '33px',
							marginBottom: '3px',
							backgroundColor: 'white',
							border: '1px solid #acacac',
						}}
						disabled={!selectedDates.fromDate || !selectedDates.toDate}
						handleClick={() => onClear()}
					/>
				</Stack>
			</Stack>
			<LabeledSelectField
				label={isRestaurant ? 'Supplier' : 'Customer'}
				placeholder="Eg All"
				options={
					(organizations && organizations.map((org: any) => ({ id: org.id, value: org.name }))) ||
					[]
				}
				value={currentSelectedOrg}
				handleChange={(event) => {
					setCurrentSelectedOrg(event.target.value);
					filterByType(event.target.value);
				}}
				styles={{ height: '36px', width: '100%' }}
			/>
		</Stack>
	);
}

function TopFilters({
	searchByDate,
	filterByType,
	currentSelectedOrg,
	setCurrentSelectedOrg,
	organizations,
	isRestaurant,
}: any) {
	const isMobile = IsMobileWidth();
	const [selectedDates, setSelectedDates] = useState<any>({
		fromDate: null,
		toDate: null,
	});

	const onApply = () => {
		console.log(selectedDates);
		if (selectedDates.fromDate && selectedDates.toDate) {
			searchByDate(selectedDates);
		}
	};

	const onClear = () => {
		setSelectedDates({
			fromDate: null,
			toDate: null,
		});
		searchByDate(null);
	};

	if (isMobile) {
		return (
			<TopFIlterMobileView
				{...{
					searchByDate,
					filterByType,
					currentSelectedOrg,
					setCurrentSelectedOrg,
					organizations,
					isRestaurant,
					selectedDates,
					setSelectedDates,
					onApply,
					onClear,
				}}
			/>
		);
	}

	return (
		<Stack direction={'row'} justifyContent="space-between" p={2} gap={2} alignItems={'flex-end'}>
			<Stack>
				<Typography>Filter By Date Range</Typography>
				<Stack direction={'row'} alignItems={'flex-end'} gap={1}>
					<CustomDatePicker
						label="From"
						styles={{ height: '36px', width: 300 }}
						selectedDate={selectedDates.fromDate}
						onDateChange={(newDate) => setSelectedDates({ ...selectedDates, fromDate: newDate })}
					/>
					<CustomDatePicker
						label="To"
						styles={{ height: '36px', width: 300 }}
						selectedDate={selectedDates.toDate}
						minDate={selectedDates.toDate}
						onDateChange={(newDate) => setSelectedDates({ ...selectedDates, toDate: newDate })}
					/>
					<CustomButton
						title={'Apply'}
						styles={{ height: '33px', marginBottom: '3px' }}
						handleClick={() => onApply()}
					/>
					<CustomButton
						title={'Clear'}
						styles={{
							height: '33px',
							marginBottom: '3px',
							backgroundColor: 'white',
							border: '1px solid #acacac',
						}}
						disabled={!selectedDates.fromDate || !selectedDates.toDate}
						handleClick={() => onClear()}
					/>
				</Stack>
			</Stack>
			<LabeledSelectField
				label={isRestaurant ? 'Supplier' : 'Customer'}
				placeholder="Eg All"
				options={
					(organizations && organizations.map((org: any) => ({ id: org.id, value: org.name }))) ||
					[]
				}
				value={currentSelectedOrg}
				handleChange={(event) => {
					setCurrentSelectedOrg(event.target.value);
					filterByType(event.target.value);
				}}
				styles={{ height: '36px', width: 300 }}
			/>
		</Stack>
	);
}

function RewardStatsArea({ metrics }: any) {
	const {
		totalRedeemablePoints,
		totalRedeemableValue,
		totalRewardsPoints,
		totalRewardsValue,
		bonusRewardTotalValue,
	} = metrics || {};
	return (
		<Stack m={2} gap={8} direction={'row'} sx={{ backgroundColor: 'white', borderRadius: '8px' }}>
			<Box p={1}>
				<Typography color={'gray'} fontSize={14}>
					Total Rewards Avalable{' '}
					<Tooltip title="Total Rewards Avalable">
						<InfoOutlined sx={{ fontSize: 16 }} />
					</Tooltip>
				</Typography>
				<Typography fontSize={24} fontWeight={600}>
					{roundToInt(totalRewardsPoints)}
				</Typography>
				<Typography color={'gray'} fontSize={12}>
					Rs {roundToInt(totalRewardsValue)} value
				</Typography>
			</Box>
			<Box p={1}>
				<Typography color={'gray'} fontSize={14}>
					Redeemable{' '}
					<Tooltip title="Total Rewards Redeemable">
						<InfoOutlined sx={{ fontSize: 16 }} />
					</Tooltip>
				</Typography>
				<Typography fontSize={24} fontWeight={600}>
					{roundToInt(totalRedeemablePoints)}
				</Typography>
				<Typography color={'gray'} fontSize={12}>
					Rs {roundToInt(totalRedeemableValue)} value
				</Typography>
			</Box>
			<Box p={1}>
				<Typography color={'gray'} fontSize={14}>
					Total Bonus Avalable{' '}
					<Tooltip title="Total Bonus Avalable">
						<InfoOutlined sx={{ fontSize: 16 }} />
					</Tooltip>
				</Typography>
				<Typography fontSize={24} fontWeight={600}>
					{roundToInt(bonusRewardTotalValue)}
				</Typography>
				<Typography color={'gray'} fontSize={12}>
					Rs {roundToInt(bonusRewardTotalValue)} value
				</Typography>
			</Box>
		</Stack>
	);
}

function PointsOfLastThreeMonths({ lastThreeMonths }: any) {
	if (!lastThreeMonths) return null;
	return (
		<Stack m={2} gap={8} direction={'row'} sx={{ backgroundColor: 'white', borderRadius: '8px' }}>
			<Box p={1}>
				<Typography color={'gray'} fontSize={20}>
					Earned Points in the last 3 Months
				</Typography>
				<Stack direction={'row'} mt={1} gap={8}>
					{lastThreeMonths.map(({ month, value }: any) => (
						<Stack direction={'row'} gap={2} alignItems={'center'}>
							<Typography color={'black'} fontSize={16} fontWeight={400}>
								{month}
							</Typography>
							<Typography color={'black'} fontSize={16} fontWeight={700}>
								{value}
							</Typography>
						</Stack>
					))}
				</Stack>
			</Box>
		</Stack>
	);
}

const getColumns = (isRestaurant: any) => [
	{
		field: 'createdAt',
		headerName: 'Date',
		width: 200,
		renderCell: (params: any) => {
			return moment(params?.row?.createdAt).format('DD-MM-YY hh:mm A');
		},
	},
	{
		field: 'supplier',
		headerName: isRestaurant ? 'Supplier' : 'Customer',
		width: 250,
		renderCell: (params: any) => {
			return isRestaurant ? params?.row?.supplier?.name : params?.row?.restaurant?.name;
		},
	},
	{
		field: 'order_no',
		headerName: 'Order #',
		width: 150,
		renderCell: (params: any) => {
			return params?.row?.order?.orderTimeId;
		},
	},
	{
		field: 'order_amount',
		headerName: 'Order Amount',
		width: 200,
	},
	{
		field: 'totalRedemptionPoints',
		headerName: 'Rewards Earned',
		width: 150,
		renderCell: (params: any) => {
			// round off to int
			const roundedToInt = roundToInt(params?.row?.totalRedemptionPoints);
			return roundedToInt;
		},
	},
	{
		field: 'totalRedeemableValue',
		headerName: 'Rewards Value',
		width: 150,
		renderCell: (params: any) => {
			// round off to int
			const roundedToInt = roundToInt(params?.row?.totalRedeemableValue);
			return roundedToInt;
		},
	},
	{
		field: 'status',
		headerName: 'Status',
		width: 150,
	},
	{
		field: 'remarks',
		headerName: 'Remarks',
		width: 250,
	},
];

function RewardActivityTable({ tableData, totalPages, page, handlePageChange, isRestaurant }: any) {
	const columns = getColumns(isRestaurant);
	const isMobile = IsMobileWidth();
	return (
		<Box
			m={1}
			sx={{ width: isMobile ? 'calc(100vw - 10px)' : 'calc(100vw - 258px)', overflowX: 'auto' }}
		>
			<CustomDataGrid2
				rows={tableData || []}
				columns={columns}
				onRowsSelectionHandler={() => {}}
				handleRowClick={() => {}}
				checkboxSelection={false}
				style={{
					transition: 'height 0.3s ease',
					maxHeight: 'calc(100vh - 350px)',
					minHeight: 'calc(100vh - 350px)',
				}}
			/>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					width: '100%',
					padding: '10px',
					marginBottom: 5,
				}}
			>
				<Pagination color="primary" count={totalPages} page={page} onChange={handlePageChange} />
			</Box>
		</Box>
	);
}

function RewardsDashboard() {
	const location = useLocation();
	const navigate = useNavigate();
	const currentUser: any = useAppSelector((state) => state?.currentUser?.value);
	const isRestaurant = currentUser?.type?.toLowerCase() === RESTAURANT;
	const [totalPages, setTotalPages] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [dashboardData, setDashboardData] = useState({});
	const [organizations, setOrganizations] = useState([]);
	const [currentSelectedOrg, setCurrentSelectedOrg] = useState('All');
	const limit = 25;
	const [page, setPage] = useState(1);
	let params = {
		limit: limit,
		page: page,
		from: null,
		to: null,
		supplierId: null,
		restaurantId: null,
	};
	const { id } = useParams();
	const { apiService }: any = React.useContext(ApplicationContext);
	const [alert, setAlert] = useState({
		message: '',
		severity: 'success',
	});

	function fetchRewardsDashboard() {
		setIsLoading(true);
		apiService.getRewardDashboard(
			(response: any) => {
				console.log(response);
				const data = response?.data?.data;
				const { totalCount } = data || {};
				setDashboardData(data);
				setTotalPages(Math.ceil(totalCount / limit));
				setIsLoading(false);
			},
			(error: any) => {
				console.log(error);
				setAlert({ message: error.response.data.message, severity: 'error' });
				setIsLoading(false);
			},
			id,
			params
		);
	}

	function getOrganizations() {
		apiService.getRewardOrganizations(
			(response: any) => {
				console.log(response);
				const data = response?.data?.data;
				const { organizations } = data || {};
				if (organizations) {
					const defaultOrg = { id: 'All', name: 'All' };
					const orgs = [defaultOrg, ...organizations];
					setOrganizations(orgs);
				}
			},
			(error: any) => {
				console.log(error);
				setAlert({ message: error.response.data.message, severity: 'error' });
			},
			id,
			params
		);
	}

	const handlePageChange = (event: any, value: number) => {
		if (page !== value) {
			setPage(value);
		}
	};

	useEffect(() => {
		fetchRewardsDashboard();
		getOrganizations();
	}, [page]);

	const searchByDate = (selectedDates: any) => {
		params.from =
			selectedDates?.fromDate && moment(selectedDates.fromDate.toDate()).format('YYYY-MM-DD');
		params.to = selectedDates?.toDate && moment(selectedDates.toDate.toDate()).format('YYYY-MM-DD');
		fetchRewardsDashboard();
	};

	const filterByType = (type: any) => {
		console.log(type);
		if (type !== 'All') {
			if (isRestaurant) {
				params.supplierId = type;
			} else {
				params.restaurantId = type;
			}
		} else {
			params.supplierId = null;
			params.restaurantId = null;
		}
		fetchRewardsDashboard();
	};

	return (
		<StyledContainer>
			<PageHeader title="Rewards Dashboard" />
			<Box sx={{ overflowY: 'auto' }}>
				<TopFilters
					searchByDate={searchByDate}
					filterByType={filterByType}
					organizations={organizations}
					{...{ currentSelectedOrg, setCurrentSelectedOrg, isRestaurant }}
				/>
				<RewardStatsArea metrics={dashboardData?.metrics} />
				<PointsOfLastThreeMonths lastThreeMonths={dashboardData?.metrics?.rewardPointsByMonth} />
				<RewardActivityTable
					tableData={dashboardData?.rewardTransactions}
					totalPages={totalPages}
					page={page}
					handlePageChange={handlePageChange}
					isRestaurant={isRestaurant}
				/>
			</Box>

			{/* <RenderContent location={location.pathname} {...{ apiService, setAlert, id, navigate }} /> */}
			{/* <AddReward /> */}
			{alert?.message !== '' ? <CustomAlert alert={alert} setAlert={setAlert} /> : null}
		</StyledContainer>
	);
}

export default RewardsDashboard;
